import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Typography from '../../../UniformComponents/Typography'

const BaseSize = observer((({ store, position }) => {
    const slide = store.activeSlide
    const question = slide.question.get(position)

    if (!question) return <Typography type="tiny">{i18n.t('powerpoint.slide.base-size')}</Typography>

    const data = store.getChartDataForQuestion(question?.questionId, position)
    const comparisonYears = [...question.comparisonYears, question.year]
    const baseSizes = Object.entries(data?.baseSizes ?? {})
        .sort((a, b) => a[0] - b[0])
        .filter(([k]) => comparisonYears.includes(Number(k)))
        .map(([k, v]) => `${k}: ${v}`)
        .join(' / ')

    const text = question.questionTypeCode === 'OD'
        ? i18n.t('powerpoint.slide.base-size-brackets')
        : `${i18n.t('powerpoint.slide.base-size')} - ${baseSizes}`

    return <Typography type="tiny">{text}</Typography>
}))

export default BaseSize
